
import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { reassignTimelineEntriesForUser, validateEntryPlacement } from "@/utils/timelineEntryReassignment";

export const useTimelineEntryReassignment = () => {
  const [isReassigning, setIsReassigning] = useState(false);
  const [reassignmentResult, setReassignmentResult] = useState<{
    movedCount: number;
    movedEntries: any[];
    errors: string[];
  } | null>(null);
  
  const queryClient = useQueryClient();

  const reassignEntries = async (userId: string, birthdate: string) => {
    setIsReassigning(true);
    try {
      const result = await reassignTimelineEntriesForUser(userId, birthdate);
      setReassignmentResult(result);
      
      if (result.movedCount > 0) {
        // Invalidate timeline-related queries to refresh the UI
        await queryClient.invalidateQueries({ queryKey: ['timeline-entries', userId] });
        await queryClient.invalidateQueries({ queryKey: ['timeline', userId] });
      }
      
      return result;
    } catch (error) {
      console.error('Reassignment failed:', error);
      const errorResult = {
        movedCount: 0,
        movedEntries: [],
        errors: [error instanceof Error ? error.message : 'Unknown error']
      };
      setReassignmentResult(errorResult);
      return errorResult;
    } finally {
      setIsReassigning(false);
    }
  };

  const validateEntries = async (userId: string) => {
    return await validateEntryPlacement(userId);
  };

  const clearResult = () => {
    setReassignmentResult(null);
  };

  return {
    reassignEntries,
    validateEntries,
    isReassigning,
    reassignmentResult,
    clearResult
  };
};
